import { Close } from '@mui/icons-material';
import Autocomplete from '@mui/material/Autocomplete';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    IconButton,
    Stack,
    TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import ConfirmationModal from '../../../../components/ConfirmationModal';
import useDialog from '../../../../hooks/useDialog';
import useErrors from '../../../../hooks/useErrors';
import server from '../../../../services/server';
import { useFetch } from '../../../../hooks/useFecth';

function Edit({ id, mutate }) {
    const { data } = useFetch(id ? `settings/items/${id}` : null);
    return <Form data={data} mutate={mutate} />;
}

function Form({ data, mutate }) {
    const { open, handleClose } = useDialog('#setting');
    const { setErrors, enqueueSnackbar } = useErrors();
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [confirmAction, setConfirmAction] = React.useState(null);
    const { data: clubs } = useFetch('clubs');
    const clubOptions = Array.isArray(clubs) ? clubs : clubs?.data ?? clubs?.rows ?? [];


    const { values, handleSubmit, setValues, handleChange, isSubmitting, setFieldValue } = useFormik({
        initialValues: {
            project_pages: '',
            key: '',
            value: '',
            clubId: '',
        },
        onSubmit: async (vals, { setSubmitting }) => {
            try {
                const payload = {
                    project_pages: vals.project_pages || undefined,
                    key: vals.key || undefined,
                    value: vals.value || undefined,
                    clubId: vals.clubId ? Number(vals.clubId) : undefined,
                };
                if (vals.id) {
                    await server.put(`settings/items/${vals.id}`, payload);
                    enqueueSnackbar('Configuração atualizada.');
                } else {
                    await server.post('settings/items', payload);
                    enqueueSnackbar('Configuração criada.');
                }
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            }
            setSubmitting(false);
        },
    });

    const handleDelete = () => {
        setConfirmAction(() => async () => {
            try {
                await server.delete(`settings/items/${values.id}`);
                enqueueSnackbar('Configuração excluída.');
                await mutate();
                handleClose();
            } catch (error) {
                setErrors(error);
            }
            setConfirmOpen(false);
        });
        setConfirmOpen(true);
    };

    useEffect(() => {
        if (data) {
            setValues({
                id: data.id,
                project_pages: data.project_pages ?? '',
                key: data.key ?? '',
                value: data.value ?? '',
                clubId: data.clubId ?? '',
            }, true);
        }
    }, [data, setValues]);

    return (
        <>
            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <DialogTitle>{values.id ? 'Editar configuração' : 'Nova configuração'}</DialogTitle>
                    <IconButton onClick={handleClose} aria-label="close" sx={{ mr: 2 }}>
                        <Close />
                    </IconButton>
                </Stack>
                <Divider />
                <DialogContent component="form" onSubmit={handleSubmit}>
                    <Stack rowGap={2} pt={1}>
                        {/* <TextField
                            label="Páginas do projeto"
                            name="project_pages"
                            value={values.project_pages}
                            onChange={handleChange}
                            fullWidth
                        /> */}
                        <TextField
                            label="Chave"
                            name="key"
                            value={values.key}
                            onChange={handleChange}
                            fullWidth
                        />
                        <TextField
                            label="Valor"
                            name="value"
                            value={values.value}
                            onChange={handleChange}
                            fullWidth
                            multiline
                        />
                        <Autocomplete
                            options={clubOptions}
                            getOptionLabel={option => option?.name ?? ''}
                            value={clubOptions.find(c => c.id === values.clubId) ?? null}
                            onChange={(_, newValue) => setFieldValue('clubId', newValue?.id ?? '')}
                            isOptionEqualToValue={(option, value) => option?.id === value?.id}
                            renderInput={params => (
                                <TextField {...params} label="Clube" placeholder="Digite para buscar..." />
                            )}
                        />
                    </Stack>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Stack direction="row" alignItems="center" spacing={2}>
                        {values.id && (
                            <Button variant="outlined" color="error" onClick={handleDelete}>
                                Excluir
                            </Button>
                        )}
                        <Box sx={{ flex: 1 }} />
                        <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                            Salvar
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
            <ConfirmationModal
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={confirmAction}
                title="Excluir configuração"
                message="Tem certeza que deseja excluir este item?"
            />
        </>
    );
}

export default function DialogSetting({ mutate }) {
    const { open, id } = useDialog('#setting');
    if (open && id) return <Edit id={id} mutate={mutate} />;
    if (open) return <Form mutate={mutate} />;
    return null;
}
